

export function formatCreditReport(response) {
  if(response?.status === "error") return
  console.log("coming reponse data", response);
  
    const mainData = response?.data?.steps || response?.steps;
    let index;
    mainData?.forEach((element, idx) => {
      if (element?.name === "GetCustomerAssets") {
        index = idx
      }
    });

    const asset = mainData[index]?.response?.GetCustomerAssetsResponse?.GetCustomerAssetsSuccess?.Asset
    const userData = asset.TrueLinkCreditReport?.Borrower
    const reportDate = asset.CreationDate
    const accounts = asset.TrueLinkCreditReport?.TradeLinePartition
    const enquiries = asset.TrueLinkCreditReport?.InquiryPartition
    const allPhones = userData?.BorrowerTelephone
    const controlNumber = response?.data?.report_summary?.control_number
    const reporteDate = response?.data?.report_summary?.report_date
    const reportSummary = response?.data?.report_summary

    let activeAccountsCount = 0;

    let pan; 
    let ckyc;
    let rationCard;

    accounts.forEach(element => {
      if (element?.Tradeline?.dateClosed) {
        activeAccountsCount = activeAccountsCount +1
      }
    });

    userData?.IdentifierPartition?.Identifier?.forEach(element => {
      if (element?.ID?.IdentifierName === "TaxId") {
        pan = element?.ID?.Id
      } else  if (element?.ID?.IdentifierName === "CkycId") {
        ckyc = element?.ID?.Id
      } else  if (element?.ID?.IdentifierName === "RationCardId") {
        rationCard = element?.ID?.Id
      }
    });

  return {
    personal: {
      name: userData?.BorrowerName?.Name?.Forename,
      phone: userData?.BorrowerTelephone?.[0]?.PhoneNumber?.Number,
      pan,
      ckyc,
      rationCard,
      email: userData?.EmailAddress?.Email?.toLowerCase(),
      dob: userData?.Birth?.date,
      address: userData?.BorrowerAddress?.[0]?.CreditAddress?.StreetAddress,
      gender: userData?.Gender,
      allPhones,
      allAddresses: userData?.BorrowerAddress
    },
    controlNumber,
    reporteDate,
    reportSummary,
    employment: userData?.Employer,
    reportDate: new Date(reportDate)?.toDateString(),
    activeAccountsCount,
    accounts,
    enquiries,
    totalEnquiries: enquiries?.length,
    asset,

    score: {
      value: userData?.CreditScore?.riskScore,
    },
  };
}
